rhm.team.products = (function (module) {
  'use strict';
  var settings = { productsContainer: '.teamProducts' };

  var makeRequest = function (URL) {
    return fetch(URL, {
      method: 'GET',
      headers: { Accept: 'text/html' },
    }).then(function (res) {
      if (!res.ok) throw new Error(String(res.status));
      return res.text();
    });
  };

  var getProducts = function () {
    var url =
      `${window.theme.routes.search_url}?type=product&view=team_ajax&q=${encodeURIComponent(rhm.team.settings.name)}`
    rhm.team.settings.name;
    var container = document.querySelector(settings.productsContainer);
    if (!container) return;
    makeRequest(url).then(function (data) {
      var doc = new DOMParser().parseFromString(data, 'text/html');
      var items = doc.querySelectorAll('.products li');
      container.innerHTML = '';
      items.forEach(function (li) {
        container.appendChild(document.importNode(li, true));
      });
    });
  };

  var init = function () {
    getProducts();
  };

  module = { getProducts: getProducts, init: init };
  return module;
})(rhm.team.products);
